import theme from './theme.json';
export const nafColor = theme.nafColor;
